/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItem_viewer = {
    readonly isSeoQuicklookEnabled: boolean | null;
    readonly isFavoritesEnabled: boolean | null;
    readonly " $refType": "PdpRespSimilarItem_viewer";
};
export type PdpRespSimilarItem_viewer$data = PdpRespSimilarItem_viewer;
export type PdpRespSimilarItem_viewer$key = {
    readonly " $data"?: PdpRespSimilarItem_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItem_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSeoQuicklookEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    }
  ]
};
(node as any).hash = '7c25128694f1321b4000ed8c8b6a13c3';
export default node;
